<template>
    <PlantConfigurationNotificationSubscribers :plantID="plantID"></PlantConfigurationNotificationSubscribers>
</template>

<script>
import PlantConfigurationNotificationSubscribers from '@/components/plants/configuration/PlantConfigurationNotificationSubscribers.vue';

export default {
    components: {
        PlantConfigurationNotificationSubscribers
    },
    data() {
        return {
            
        };
    },
    computed: {
        plantID() {
            return parseInt(this.$route.params.plantID);
        }
    },
    methods: {

    },
    created() {
        
    }
}
</script>

<style>

</style>
